import React from 'react'
import sw from '../../utils/switch'
import loadable from '@loadable/component'
import withComponentBase from '../helpers/with-component-base'

const Grid = loadable(() => import('./collection-grid'))
const Logos = loadable(() => import('./collection-image-logo'))
const Tabs = loadable(() => import('./collection-tabs'))
const Pills = loadable(() => import('./collection-pills'))

// eslint-disable-next-line import/no-anonymous-default-export
export default withComponentBase(
  (props) =>
    sw({
      grid: () => <Grid {...props} />,
      proposition: () => <Grid {...props} />,
      logos: () => <Logos {...props} />,
      'large-logos': () => <Logos {...props} variant='large' />,
      tabs: () => <Tabs {...props} />,
      pills: () => <Pills {...props} />,
      default: () => null,
    })(props.layout),
  (props) => ({
    withHeaderFooter: true,
    headerStyles:
      props.layout === 'pills'
        ? {
            h2: {
              textAlign: 'center',
            },
          }
        : {},
  }),
)
